import React from 'react'
import PropTypes from 'prop-types'
import {format} from 'ag-common/facades'

function DatePickerKWCell({date}) {
  return <div className="date-picker-kw-cell noselect">{format(date, 'I')}</div>
}

DatePickerKWCell.propTypes = {
  date: PropTypes.instanceOf(Date),
}

export default DatePickerKWCell
